import './App.css';
import Navbar from './Component/Navbar';
import Home from './Component/Home';
import About from './Component/About';
import Experience from './Component/Experience/Experience';
import Project from './Component/Project';
import Skill from './Component/Skill';
import { Contact } from './Component/Contact';

function App() {
  return (
    <div className="App">
      <a className="skip-link" href="#main">Skip to content</a>
      <Navbar />
      <main id="main">
        <Home />
        <About />
        <Experience />
        <Project />
        <Skill />
        <Contact />
      </main>
      <footer className="footer">
        <span>Designed &amp; built by Himanshu Singh</span>
        <span>© {new Date().getFullYear()} · Crafted with React</span>
      </footer>
    </div>
  );
}

export default App;
